import React from 'react';
import { useTranslation } from 'react-i18next';
import { HelpArticleMeta } from './helpCenter';

const badgeClass = 'px-2 py-0.5 rounded-full text-xs font-medium';

/** The article type. Grayscale on purpose: the tenant primary is the only
 *  accent. No draft badge (PO, 2026-09-28): the first article set reads well
 *  enough that the badge did more harm than good; `status` in the article
 *  header stays as the internal record of what has been walked in the UI. */
const HelpArticleBadges = ({ article }: { article: HelpArticleMeta }) => {
    const { t } = useTranslation();
    return (
        <div className={'flex flex-wrap gap-2'}>
            <span className={`${badgeClass} bg-foreground/5 text-foreground/60`}>{t(`help.types.${article.type}`)}</span>
        </div>
    );
};

export default HelpArticleBadges;
